import React, { useState } from 'react'
import { Switch, useParams, useRouteMatch } from 'react-router-dom'
import SettingsRoute from './SettingsRoute'
import SettingsMenu from './SettingsMenu'
import SettingsMenuCompact from './SettingsMenuCompact'
import CertificatesSettings from '../../certificates/components/CertificatesSettings'
import DetailsSettings from '../../details/components/DetailsSettings'
import { useTranslation } from 'react-i18next'
import Importing from '../../importing/components/Importing'
import Records from '../../records/components/Records'
import Frequencies from '../../frequencies/components/Frequencies'
import States from '../../states/components/States'
import Tags from '../../tags/components/Tags'
import Actions from '../../actions/components/Actions'
import Invitations from '../../invitations/components/Invitations'
import Checklists from '../../checklists/components/Checklists'
import Filters from '../../filters/components/Filters'
import Address from '../../address/components/Address'
import Contacts from '../../contacts/components/Contacts'
import Blueprint from '../../blueprints/components/Blueprint'

type Params = {
  accountId: string
}

function SettingsRoutes() {
  const { t } = useTranslation([
    'settings_details',
    'settings_certificates',
    'settings_importing',
    'settings_tags',
    'settings_actions',
    'settings_checklists',
    'settings_invitations',
    'settings_records',
    'settings_states',
    'settings_frequencies',
    'settings_filters',
    'settings_address',
    'settings_contacts',
    'settings_blueprint'
  ])

  const { path } = useRouteMatch()
  const [compactMenuOpen, setCompactMenuOpen] = useState(false)
  const { accountId } = useParams() as Params

  function onHamburgerClick() {
    setCompactMenuOpen(!compactMenuOpen)
  }

  return (
    <>
      <SettingsMenu />

      {compactMenuOpen && (
        <SettingsMenuCompact onNavigate={() => setCompactMenuOpen(false)} />
      )}

      <Switch>
        <SettingsRoute
          exact path={`${path}`}
          component={DetailsSettings}
          title={t('settings_details:settings_title')}
          accountId={accountId}
          onHamburgerClick={onHamburgerClick} />

        <SettingsRoute
          exact path={`${path}/address`}
          component={Address}
          title={t('settings_address:settings_title')}
          accountId={accountId}
          onHamburgerClick={onHamburgerClick} />

        <SettingsRoute
          exact path={`${path}/contacts`}
          component={Contacts}
          title={t('settings_contacts:settings_title')}
          accountId={accountId}
          onHamburgerClick={onHamburgerClick} />

        <SettingsRoute
          exact path={`${path}/certificates`}
          component={CertificatesSettings}
          title={t('settings_certificates:settings_title')}
          accountId={accountId}
          onHamburgerClick={onHamburgerClick} />

        <SettingsRoute
          exact path={`${path}/importing`}
          component={Importing}
          title={t('settings_importing:settings_title')}
          accountId={accountId}
          onHamburgerClick={onHamburgerClick} />

        <SettingsRoute
          exact path={`${path}/records`}
          component={Records}
          title={t('settings_records:settings_title')}
          accountId={accountId}
          onHamburgerClick={onHamburgerClick} />

        <SettingsRoute
          exact path={`${path}/frequencies`}
          component={Frequencies}
          title={t('settings_frequencies:settings_title')}
          accountId={accountId}
          onHamburgerClick={onHamburgerClick} />

        <SettingsRoute
          exact path={`${path}/states`}
          component={States}
          title={t('settings_states:settings_title')}
          accountId={accountId}
          onHamburgerClick={onHamburgerClick} />

        <SettingsRoute
          exact path={`${path}/tags`}
          component={Tags}
          title={t('settings_frequencies:settings_title')}
          accountId={accountId}
          onHamburgerClick={onHamburgerClick} />

        <SettingsRoute
          exact path={`${path}/actions`}
          component={Actions}
          title={t('settings_actions:settings_title')}
          accountId={accountId} />

        <SettingsRoute
          exact path={`${path}/filters`}
          component={Filters}
          title={t('settings_filters:settings_title')}
          accountId={accountId}
          onHamburgerClick={onHamburgerClick} />

        <SettingsRoute
          exact path={`${path}/invitations`}
          component={Invitations}
          title={t('settings_invitations:settings_title')}
          accountId={accountId}
          onHamburgerClick={onHamburgerClick} />

        <SettingsRoute
          exact path={`${path}/checklists`}
          component={Checklists}
          title={t('settings_checklists:settings_title')}
          accountId={accountId}
          onHamburgerClick={onHamburgerClick} />

        <SettingsRoute
          exact path={`${path}/blueprint`}
          component={Blueprint}
          title={t('settings_blueprint:settings_title')}
          accountId={accountId}
          onHamburgerClick={onHamburgerClick} />
      </Switch>
    </>
  )
}

export default SettingsRoutes
